// extracted by mini-css-extract-plugin
export default {"container":"TableRow_container__c8r21"};